export default {
    init() {
        const header = document.querySelector('.header-menu');

        if (!header) {
            return;
        }

        // add scroll styling for header
        window.onscroll = function () {
            if (document.documentElement.scrollTop > header.clientHeight) {
                header.classList.add('bg-header-scroll');
            } else {
                header.classList.remove('bg-header-scroll');
            }
        };
    }
};
